// extracted by mini-css-extract-plugin
module.exports = {"root":"TextCta_root__9i4fz"};